export const useIsTextOverflowing = (textRef: React.RefObject<HTMLElement>) => {
  const isOverflowing =
    textRef.current?.scrollWidth &&
    textRef.current?.clientWidth &&
    textRef.current?.scrollWidth > textRef.current?.clientWidth;
  return isOverflowing;
};
